import { useNode } from "@craftjs/core";
import React, { useContext } from "react";
import { SiteLogoSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import { GrigoraDashboardContext } from "../../dashboard/context";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraEditorContext } from "../../editor/context";
import { WhiteLabelContext } from "../../whitelabel";

export const SiteLogo = (props) => {
  const { __whitelabel__ } = useContext(WhiteLabelContext) ?? {};

  const { project, projectID } = useContext(GrigoraDashboardContext) ?? {};
  const editorContext = useContext(GrigoraEditorContext) ?? {};
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const { altTex, titleText } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-site-logo": true,
      [`site-logo-${id}`]: id,
    },
    blockProps.className,
  );

  var siteLogo;

  if (editorContext?.project?.sitelogo) {
    siteLogo = `https://cdn.grigora.co/projects/${projectID}/${editorContext?.project?.sitelogo}`;
  } else if (project?.sitelogo) {
    siteLogo = `https://cdn.grigora.co/projects/${projectID}/${project?.sitelogo}`;
  } else {
    siteLogo = __whitelabel__("icon", WEBCLIP_URL);
  }

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__SiteLogo(id, props)}`}</style>
      {siteLogo ? (
        <>
          <img
            title={`${titleText ? titleText : ""}`}
            alt={`${altTex ? altTex : ""}`}
            className="w-full"
            src={siteLogo}
          />
        </>
      ) : (
        <>
          <img
            title={`${titleText ? titleText : ""}`}
            alt={`${altTex ? altTex : ""}`}
            className="w-full"
            src={__whitelabel__("icon", WEBCLIP_URL)}
          />
        </>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
SiteLogo.displayName = "SiteLogo";

SiteLogo.craft = {
  name: "Site Logo",
  props: {},
  related: {
    settings: SiteLogoSettings,
    icon: icon,
    category: "site",
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
  },
  custom: {
    name: "Site Logo",
    slug: "grigora/site-logo",
  },
};
